const Footer = () => {
    return (
    <footer className="bg-body-tertiary text-center text-lg-start react-app-footer">
      <div className="text-center p-3">Thanks for visiting! 
        <a className="text-dark" href="https://github.com/taomaru"> - TaoMaru</a>
      </div>
    </footer>
    )
}

export default Footer